export const AGENT_REQUEST_CONTENT_CHANGED_EVENT = 'agent-request-content-changed';

export type AgentRequestContentChangedDetail = {
  projectId?: number;
  collectionId?: number;
  requestId?: number;
  source?: string;
  action?: string;
};

function parseOptionalId(value: unknown): number | undefined {
  if (typeof value === 'number' && !Number.isNaN(value)) return value;
  if (typeof value === 'string' && value !== '') {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? undefined : parsed;
  }
  return undefined;
}

export function dispatchAgentRequestContentChanged(
  detail: AgentRequestContentChangedDetail,
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AGENT_REQUEST_CONTENT_CHANGED_EVENT, { detail }));
}

/** Agent actions that mutate request URL / body / path_params / query_params on the server. */
const REQUEST_CONTENT_MUTATING_AGENT_ACTIONS = new Set([
  'apply_environment_variables',
  'apply_environment_variables_to_request',
  'apply_credential_placeholders',
  'apply_default_headers',
  'apply_bearer',
  'set_login_credentials',
]);

/**
 * Notify Collections (and other listeners) after agent actions that change request content
 * so the open editor can reload without a full page refresh.
 */
export function notifyAgentRequestContentChangedFromAgent(
  action: string | undefined,
  payload?: Record<string, unknown> | null,
  session?: { projectId?: number | null; environmentId?: number | null } | null,
): void {
  if (!action || !REQUEST_CONTENT_MUTATING_AGENT_ACTIONS.has(action)) return;
  dispatchAgentRequestContentChanged({
    projectId: parseOptionalId(payload?.projectId) ?? parseOptionalId(session?.projectId),
    collectionId: parseOptionalId(payload?.collectionId),
    requestId: parseOptionalId(payload?.requestId),
    source: 'agent',
    action,
  });
}
